import CryptoJS from 'crypto-js';
import appConfig from '../config/appConfig';

const encryptionKey = CryptoJS.enc.Hex.parse(appConfig.AES_KEY);
const iv = CryptoJS.enc.Hex.parse(appConfig.AES_IV);

const encryptData = (data: any): string => {
  const jsonData = JSON.stringify(data);

  const encrypted = CryptoJS.AES.encrypt(jsonData, encryptionKey, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const encryptedBytes = CryptoJS.enc.Base64.parse(encrypted.toString());
  const combinedArray = concatUint8Arrays(iv.words, encryptedBytes.words);

  return CryptoJS.enc.Base64.stringify(CryptoJS.lib.WordArray.create(combinedArray));
};

const decryptData = (encryptedData: string): any => {
  try {
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);
    const ivArray = encryptedBytes.words.slice(0, 4);
    const cipherArray = encryptedBytes.words.slice(4);

    const ivParsed = CryptoJS.lib.WordArray.create(ivArray, 16);
    const ciphertext = CryptoJS.lib.WordArray.create(cipherArray);

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext,
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, encryptionKey, {
      iv: ivParsed,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

const concatUint8Arrays = (ivWords: number[], cipherWords: number[]): number[] => {
  return [...ivWords, ...cipherWords];
};

// ✅ Export as default
const aesEncryptionService = {
  encryptData,
  decryptData,
};

export default aesEncryptionService;
